import {useEffect, useState} from "react";
import axios from "axios";
import {SEARCH_AXIOS_ANAGRAFICA_URL} from "../../../../services/utils/ApiUrls";
import {decriptMessage} from "../../../../utils/SecureData";

export default function useAnagraficaSearch(query, pageNumber, loadingInitialValue = true) {
	const [loadingSearch, setLoading] = useState(loadingInitialValue);
	const [errorSearch, setError] = useState(false);
	const [anagraficheSearch, setAnagrafiche] = useState([]);
	const [hasMoreSearch, setHasMore] = useState(false);
	
	useEffect(() => {
		setAnagrafiche([]);
		if (query.length === 0) {
			setHasMore(false);
		}
	}, [query])
	
	useEffect(() => {
		if (query.length > 0) {
			setLoading(true);
			setError(false);
			let cancel
			axios({
				methods: "GET",
				url: SEARCH_AXIOS_ANAGRAFICA_URL + pageNumber,
				params: {
					toSearch: query
				},
				cancelToken: new axios.CancelToken(c => cancel = c),
				headers: {
					Authorization: "Bearer " + decriptMessage(sessionStorage.getItem("key_asl_to")),
				}
			}).then(response => {
				setAnagrafiche(prevState => {
					let newState = [...prevState, ...response.data];
					return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				})
				setHasMore(response.data.length > 0);
				setLoading(false);
			}).catch(e => {
				if (axios.isCancel(e)) return
				setError(true)
			})
			
			return () => cancel()
		} else {
			setLoading(false);
			setError(false);
		}
	}, [query, pageNumber, hasMoreSearch])
	
	return {loadingSearch, errorSearch, anagraficheSearch, hasMoreSearch};
}
